export default {
    inject: ["getModalController"],
    computed: {
        modalController: function(){
            return this.getModalController()
        }
    }
}
